import { Link } from "react-router-dom";

import { LogoIcon } from "components/Icons";
import { UserBarWithoutAccounts } from "components/MainSidebar/UserBar/UserBar";
import ThemeSwitcher from "components/ThemeSwitcher/ThemeSwitcher";

import { AQA_LINK_HEADER } from "./AqaIds";
import HelpBar from "./HelpBar/HelpBar";

import styles from "./MainSidebar.module.scss";

export const MainSidebarWithoutAccounts = () => {
  return (
    <div
      className={styles.root}
      data-testid="sidebar-without-account"
    >
      <div className={styles.sidebarHead}>
        <Link
          key="app_header"
          to="/"
          data-testid={AQA_LINK_HEADER}
          className={styles.logo}
        >
          <LogoIcon />
        </Link>
        <UserBarWithoutAccounts />
      </div>
      <div className={styles.sidebarFooter}>
        <HelpBar />
        <ThemeSwitcher />
      </div>
    </div>
  );
};
